import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { ScrollManager } from './components/ScrollManager';
import { AuthProvider } from './auth/AuthContext';
import { AdminGuard } from './auth/AdminGuard';

const SobreNos = lazy(() => import('./pages/SobreNos').then((m) => ({ default: m.SobreNos })));
const Contato = lazy(() => import('./pages/Contato').then((m) => ({ default: m.Contato })));
const FaqPage = lazy(() => import('./pages/FaqPage').then((m) => ({ default: m.FaqPage })));
const ServicePage = lazy(() => import('./pages/ServicePage').then((m) => ({ default: m.ServicePage })));
const BlogIndex = lazy(() => import('./pages/BlogIndex').then((m) => ({ default: m.BlogIndex })));
const BlogPost = lazy(() => import('./pages/BlogPost').then((m) => ({ default: m.BlogPost })));
const AdminLogin = lazy(() => import('./pages/admin/AdminLogin').then((m) => ({ default: m.AdminLogin })));
const AdminPosts = lazy(() => import('./pages/admin/AdminPosts').then((m) => ({ default: m.AdminPosts })));
const AdminPostEditor = lazy(() => import('./pages/admin/AdminPostEditor').then((m) => ({ default: m.AdminPostEditor })));
const AdminLeads = lazy(() => import('./pages/admin/AdminLeads').then((m) => ({ default: m.AdminLeads })));
const NotFound = lazy(() => import('./pages/NotFound').then((m) => ({ default: m.NotFound })));

function PageFallback() {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="h-8 w-8 rounded-full border-2 border-neutral-200 border-t-orange animate-spin" />
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollManager />
        <Suspense fallback={<PageFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre-nos" element={<SobreNos />} />
            <Route path="/contato" element={<Contato />} />
            <Route path="/faq" element={<FaqPage />} />
            <Route path="/servicos/:slug" element={<ServicePage />} />
            <Route path="/blog" element={<BlogIndex />} />
            <Route path="/blog/:slug" element={<BlogPost />} />

            {/* Login do CMS — público */}
            <Route path="/admin/login" element={<AdminLogin />} />

            {/* Área administrativa — protegida pelo AdminGuard */}
            <Route path="/admin" element={<AdminGuard><AdminPosts /></AdminGuard>} />
            <Route path="/admin/posts/new" element={<AdminGuard><AdminPostEditor /></AdminGuard>} />
            <Route path="/admin/posts/:id/edit" element={<AdminGuard><AdminPostEditor /></AdminGuard>} />
            <Route path="/admin/leads" element={<AdminGuard><AdminLeads /></AdminGuard>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </AuthProvider>
  );
}
